import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useMemo } from 'react';
import { MENU_PAPER_MAX_HEIGHT_PX } from '../../../../components/NRAutocomplete/useNRAutocompleteSelect';
import NRSelect from '../../../../components/NRControlledSelect/NRSelect';
import {
  JIRA_ASSIGNEE_UNASSIGNED_LABEL,
  JIRA_UNASSIGNED_ASSIGNEE_ID
} from './jiraIntegration.constants';

const ASSIGNEE_MENU_PROPS = {
  PaperProps: {
    sx: {
      maxHeight: MENU_PAPER_MAX_HEIGHT_PX
    }
  }
};

function NRAssigneeOptionLabel({ avatarUrl, name, isUnassigned = false }) {
  return (
    <Box display="flex" alignItems="center" gap={1}>
      {isUnassigned ? (
        <AccountCircleOutlinedIcon sx={{ fontSize: 20, color: 'text.secondary' }} />
      ) : (
        <Avatar src={avatarUrl || undefined} alt={name} sx={{ width: 20, height: 20, fontSize: 10 }}>
          {name?.charAt(0)?.toUpperCase()}
        </Avatar>
      )}
      <Typography component="span" variant="body2">
        {name}
      </Typography>
    </Box>
  );
}

function NRJiraAssigneeSelect({
  id,
  label,
  value,
  onChange,
  users = [],
  disabled = false,
  required = false,
  sxProps
}) {
  const options = useMemo(
    () => [
      {
        value: JIRA_UNASSIGNED_ASSIGNEE_ID,
        overrideLabel: true,
        label: <NRAssigneeOptionLabel name={JIRA_ASSIGNEE_UNASSIGNED_LABEL} isUnassigned />,
        text: JIRA_ASSIGNEE_UNASSIGNED_LABEL
      },
      ...users.map(user => ({
        value: user.accountId,
        overrideLabel: true,
        label: <NRAssigneeOptionLabel avatarUrl={user.avatarUrl} name={user.displayName} />,
        text: user.displayName
      }))
    ],
    [users]
  );

  return (
    <NRSelect
      id={id}
      label={label}
      value={value}
      onChange={onChange}
      options={options}
      disabled={disabled}
      showEmptyValue={false}
      displayEmpty
      required={required}
      color="secondary"
      sxProps={sxProps}
      menuProps={ASSIGNEE_MENU_PROPS}
    />
  );
}

export default NRJiraAssigneeSelect;
